<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalLabel">
            Top {{ companies.length }} Companies by {{ allocationType }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Company Name</th>
                  <th>Company ID</th>
                  <th>Registry Devices</th>
                  <th>Estimated Production (MWh)</th>
                  <th>{{ allocationType }} Amount (MWh)</th>
                  <th>{{ allocationType }} %</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(company, index) in companies" :key="company.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ company.name }}</td>
                  <td>{{ company.id }}</td>
                  <td>{{ company.device_count }}</td>
                  <td>{{ formatLargeNumber(company.estimated_production) }}</td>
                  <td>{{ formatLargeNumber(company.allocation_amount) }}</td>
                  <td>{{ formatPercentage(company.allocation_percentage) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CompanyAllocation } from "@/admin/adminAllocationTypes";
import { formatLargeNumber } from "@/composables/formatUtils";

defineProps<{
  modalId: string;
  allocationType: string;
  companies: CompanyAllocation[];
}>();

const formatPercentage = (value: number | undefined): string => {
  if (value === null || value === undefined) {
    return "n/a";
  }
  return `${value.toFixed(1)}%`;
};
</script>

<style scoped lang="scss">
.modal-xl {
  max-width: 1200px;
}

.table {
  margin-bottom: 0;
}

thead {
  position: sticky;
  top: 0;
  background-color: var(--phoenix-gray-50);
  z-index: 1;
}

.modal-body {
  max-height: 600px;
  overflow-y: auto;
}
</style>
